import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CoachLayout from "../common/CoachLayout";
import { CoachHeader } from "../common/CoachHeader";
import greenClock from "../../images/greenClock.svg";

export const CoachFreeSpeedWorkout = () => {
  const navigate = useNavigate();

  const [openIndex, setOpenIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showPopup, setShowPopup] = useState(false); // Popup state

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const weeks = [
    { week: "Week 1", days: [{ name: "Monday", hasClock: true }, { name: "Tuesday", hasClock: true }] },
    { week: "Week 2", days: [{ name: "Monday", hasClock: true }, { name: "Tuesday", hasClock: true }] },
    { week: "Week 3", days: [{ name: "Monday", hasClock: true }, { name: "Tuesday", hasClock: true }] },
    { week: "Week 4", days: [{ name: "Monday", hasClock: true }, { name: "Tuesday", hasClock: true }] },
    { week: "Week 5", days: [{ name: "Monday", hasClock: true }, { name: "Tuesday", hasClock: true }] },
    { week: "Week 6", days: [{ name: "Monday", hasClock: true }, { name: "Tuesday", hasClock: true }] },
  ];

  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleFreeWarmupClick = () => {
    navigate('/coach/free-warmup-routine/phase');
  };

  return (
    <CoachLayout>
      <div className="bg-white">
        <CoachHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">
          <div className="flex justify-between gap-[68px] mb-4 px-5">
            <button onClick={handleFreeWarmupClick} className="text-lightSmock text-base pb-2 font-normal">
              Warmup Routine
            </button>
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Speed Workout
            </button>
          </div>

          <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
            {weeks.map((week, index) => (
              <div key={index} className={`${openIndex === index && "!border-0 bg-[#242424]"} py-[15px] px-5 border-b border-white/20`}>
                <button
                  className="w-full flex justify-between items-center gap-5 text-white text-base font-normal"
                  onClick={() => toggleAccordion(index)}
                >
                  <p>{week.week}</p>
                  <span
                    className={`transform transition-transform ${openIndex === index ? "rotate-180" : ""}`}
                  >
                    <ArrowD />
                  </span>
                </button>
                {openIndex === index && (
                  <div className="p-[0px_0px_0px_15px]">
                    {week.days.map((day, i) => (
                      <div
                        key={i}
                        className="p-[15px_0px] flex justify-between items-center border-b border-white/20 last:border-b-0"
                        onClick={() => setShowPopup(true)}
                      >
                        {day.name}
                        {day.hasClock && <img src={greenClock} alt="green" className="object-contain" />}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm text-center">
              <h2 className="text-lg font-bold mb-4">Access Restricted</h2>
              <p className="text-gray-700 mb-4">You need to purchase a plan to access this content.</p>
              <button
                onClick={closePopup}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </CoachLayout>
  );
};

const ArrowG = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowL = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 rotate-180 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path d="M13 1L7 7L1 1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
